/**
 * Cross-feature utilities for formatting and displaying assignee lists.
 * Used by any feature card or list item that shows assignees.
 */

/**
 * Formats an assignee list for compact display in a card.
 * Shows the first assignee with a bracketed overflow count if there are more.
 *
 * Examples:
 *   []                          → ''
 *   ['alice']                   → 'alice'
 *   ['alice', 'bob', 'charlie'] → 'alice (+2)'
 */
export function formatAssigneeLabel(
  assignees: readonly string[] | null | undefined,
): string {
  if (!assignees || assignees.length === 0) return '';
  const first = assignees[0] ?? '';
  if (assignees.length === 1) return first;
  return `${first} (+${assignees.length - 1})`;
}
